import * as React from "react";
import Modal from "react-bootstrap/Modal";
import { LSM_LogicSolverSheet } from "../models/LSM_LogicSolverSheet";
import { SilModal } from "./SilModal";
import { Config, isRequired, validateValueIsInRange, isNumber, ValueDesc, generateInputFields, getFirstError, generateDeviceRow, getDefault } from "../formHelpers";

interface Props {
  closeModal: () => void;
  shownModal: string;
  logicSheet: LSM_LogicSolverSheet;
  saveCustomLogicSolver: (lsm_LogicSolverSheet: LSM_LogicSolverSheet, file: File) => void;
}

interface State {
  closeFocus: boolean;
  logicSheet?: Partial<LSM_LogicSolverSheet>;
}

const logicConfig: Config<LSM_LogicSolverSheet> = {
  source: {
    valueName: 'source',
    display: 'Data Source',
    inputProps: { maxLength: 10 },
    validators: [isRequired]
  },
  deviceID: {
    valueName: 'deviceID',
    display: 'Logic Solver ID',
    inputProps: { maxLength: 10 },
    validators: [isRequired]
  },
  deviceType: {
    valueName: 'deviceType',
    display: 'Logic Solver Type',
    validators: [isRequired]
  },
  deviceDescription: {
    valueName: 'deviceDescription',
    display: 'Logic Solver Description',
  },
  voting: {
    valueName: 'voting',
    display: 'Voting',
  },
  tiYears: {
    valueName: 'tiYears',
    display: 'TI (Yr)',
    inputProps: { maxLength: 5 },
    validators: [isRequired, isNumber]
  },
  pfdAverage: {
    valueName: 'pfdAverage',
    display: 'PFDavg',
    inputProps: { maxLength: 15 },
    validators: [isRequired, isNumber]
  },
  stR1Year: {
    valueName: 'stR1Year',
    display: 'STR (1/Yr)',
    inputProps: { maxLength: 15 },
    validators: [isRequired, isNumber]
  },
  hft: {
    valueName: 'hft',
    display: 'HFT',
    validators: [isRequired],
    type: {
      type: "select",
      options: [0, 1, 2]
    },
    defaultValue:0
  },
  lnts: {
    valueName: 'lnts',
    display: 'Notes',
  }
};

export class CustomerLogicModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      closeFocus: false,
      logicSheet: getDefault(logicConfig)
    }
  }

  private fileRef = React.createRef<HTMLInputElement>();

  inputStyle: React.CSSProperties = {
    backgroundColor: "white"
  }

  handleClick = (e: React.MouseEvent) => {
    
    const file = this.fileRef.current.files[0];
    this.props.saveCustomLogicSolver(this.state.logicSheet as any, file);
    this.props.closeModal();
  }

  generateRow = (desc: ValueDesc<LSM_LogicSolverSheet>) => {
    const logicSheet = this.props.logicSheet ? this.props.logicSheet : this.state.logicSheet;
    return generateDeviceRow(
      desc,
      logicSheet,
      (st) => this.setState({ logicSheet: st }),
      this.props.logicSheet != null);
  }

  render() {
    const logicSheet = this.props.logicSheet || this.state.logicSheet;
    var firstError = getFirstError(logicSheet, logicConfig);

    return (
      <SilModal title="Customer Logic" closeModal={this.props.closeModal}>
        <div id="logicpopup" style={{ width: 'auto', display: 'block', minHeight: '98.8667px', height: 'auto' }} className="ui-dialog-content ui-widget-content">
          <table>
            <tbody>
              {this.generateRow(logicConfig.source)}
              {this.generateRow(logicConfig.deviceID)}
              {this.generateRow(logicConfig.deviceType)}
              {this.generateRow(logicConfig.deviceDescription)}
              {this.generateRow(logicConfig.voting)}
              {this.generateRow(logicConfig.tiYears)}
              {this.generateRow(logicConfig.pfdAverage)}
              {this.generateRow(logicConfig.stR1Year)}
              {this.generateRow(logicConfig.hft)}
              <tr>
                <td className="custom-support-label">
                  <span id="Label46">Note </span>
                </td>
                <td className="custom_device_text">
                  <textarea rows={2} cols={20}
                    disabled={this.props.logicSheet == null ? false : true}
                    style={{
                      backgroundColor: "white",
                      height: "100px",
                      width:"100%"
                    }}
                    {...generateInputFields(logicSheet, logicConfig.lnts, (obj) => this.setState({ logicSheet: obj }))} />
                </td>
              </tr>
            </tbody></table>
          <div className="form-group">
            <label htmlFor="logicsolverfileimage">Select Alternate User Image File (optional):</label>
            <input type="file" multiple={true} name="LogicSolverFileUpload" id="LogicSolverFileUpload" ref={this.fileRef} />
            <p className="help-block">Select the image file to represent this custom logic solver.</p>
          </div>
          {firstError != null ? <div className="custom-errors"><label>{firstError}</label></div> : ''}
          {this.props.logicSheet == null ?
            <div style={{ textAlign: "center" }}>
              <input
                type="submit"
                name="Btn_save_logic"
                defaultValue="Save"
                id="Btn_save_logic"
                disabled={firstError != null}
                className={'edit-button ' + (firstError != null ? 'disabled green-button' : 'green-button')}
                onClick={(e: React.MouseEvent) => this.handleClick(e)} />
            </div>
            :
            null
          }
        </div>
      </SilModal>
    );
  }
}